import React from 'react';
import {
    Card, CardBody, CardTitle,
    CardText, Col, Row, Container,
    CardSubtitle
} from 'reactstrap';
import { Link } from 'react-router-dom'
import AuthComponent from '../components/AuthComponent'
import MapComponent from "../components/MapComponent";
import '../styles/LinkPage.css'
import { PREZZI } from '../constants'

export default class EventsPage extends AuthComponent {

    render() {
        
        return (
            <Container className="LinkPage">
                <h4>PROGRAMMA CLAN SCHIRATTI 2025</h4>
                <h6>Qui sono elencati tutti gli eventi del raduno con data, orario e mappa del luogo. Questi eventi sono
                    facoltativi, nel senso che non e' necessario attenderli tutti per essere considerato uno schiratto vero. 
                    Quindi i giorni piu' importanti del raduno sono il sabato pomeriggio e la domenica. <br />
                    Qualora ci fossero variazioni, vi informeremo degli aggiornamenti via email. 
                    Per prenotare la partecipazione, pasti e libro navigate alla  
                    <Link to="/booking" className="inactive"> pagina delle prenotazioni</Link>.
                </h6>
                
                    <Card>
                        <CardBody>
                            <CardTitle>Venerdì 29 Agosto, 2025</CardTitle>
                            <CardText>Per chi arriva il Venerdi', ci sarà l'accoglienza dei convenuti presso la pizzeria Rico's 3 
                                La Forneria, dove sarà riservato per noi il giardino che dà sulla riva del fiume Soligo ed è dirimpetto 
                                alla farmacia Schiratti.</CardText>
                        </CardBody>
                    </Card>
                    <Row className="section-panel">
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle>Serata da <a href="http://www.ricos3.it/" target="_blank" rel="noopener noreferrer">
                                Rico's 3 La Forneria
                                    </a>
                                </CardTitle>
                                <CardText>Piazza Vittorio Emanuele II', 38, Pieve di Soligo</CardText>
                                <CardText>dalle 18:45 alle 23:00</CardText>
                                <CardText>Il locale è situato dove un tempo c'era il Dancing Rico's Club 
                                    accanto all'albergo Leon d'Oro ed è ora gestito dai tre fratelli 
                                    Federico (6351), Benedetta (6352) e Giovanni (6353) Ricci, 
                                    che vi accoglieranno con un "giro pizza" di assaggi di pizze speciali + acqua e vino.
                                    In quest’occasione ci sarà un tavolo di check in per la consegna della coccarda e per
                                    acquistare il libro (in contanti).
                                </CardText>
                                <CardText>Costo: per gli adulti {PREZZI.RICOs_a}€ e per i bambini {PREZZI.RICOs_b}€ 
                                    da pagare all'ingresso in pizzeria alla cassa</CardText>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <CardBody>
                                <div key={1} >
                                    <MapComponent lat={45.899400554682636} lng={12.173685668850753} name="Rico's 3 La Forneria"/>, 
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Card>
                    <CardBody>
                        <CardTitle>Sabato 30 Agosto, 2025 - GIORNATA D"INCONTRI</CardTitle>
                        <CardText>
                        La giornata è dedicata agli incontri per una conoscenza reciproca e per dar modo alle
                        nuove generazioni (e non solo nuove) di incontrarsi passeggiando e chiacchierando
                        nell’esplorazione del territorio.
                        Le escursioni si svolgeranno tra le colline da Conegliano a Valdobbiadene, patrimonio dell’umanità UNESCO, 
                        nel momento più affascinante dell’anno: la vendemmia.<br />
                        Sono organizzate per gruppi con un accompagnatore che li condurrà per tutto il tragitto.  
                        La partenza alla mattina è prevista da punti diversi a seconda delle gite.
                        (Ricordate che sabato mattina il traffico è interdetto al centro di Pieve di Soligo per il mercato settimanale). 
                        <ul>
                            <li>GIRO 1 - STORIA IN PILLOLE - Accompagnatore Giovanni Schiratti 682 <br />
                            Storia degli Schiratti - storia della Strada del Vino Bianco - Bepi Schiratti un ragazzo del ’99 e la grande guerra 
                            tra Grappa e Piave.<br />
                            Giro in auto a tappe. Ritrovo presso il parcheggio dell’associazione pro loco di Soligo in via Giacomo Battistella 1
                            alle ore 9.30. Salita in auto a Col San Gallo (anche lì c'è parcheggio) con inquadramento e vista sul Quartier 
                            del Piave. 30 minuti di "storia in pillole". Partenza per il giro strada del prosecco (Col San Martino, Guia, Santo 
                            Stefano, Colbertaldo), quindi si va all’Isola dei Morti (anche lì bel parcheggio). Passeggiata fino al Piave, e storia 
                            della grande guerra 1917-1918. 
                            </li>
                            <li>GIRO 2 - Giro dei DUE CASTELLI - Accompagnatrice Carlotta Val 6323<br />
                            Giro a piedi 6,5 km dei castelli con una guida storica  che ci illustrerà alla partenza 
                            la torre di Collalto e le sua storie e all’arrivo il castello di San Salvatore a Susegana. <br />
                            La partenza e' alle 10.00 dal parcheggio di Collalto in via Strada di Collato 42, poco sotto l’incrocio tra Strada di Collalto e via Morgante . 
                            Da qui salite verso la chiesa attraversando 2 porte sulle mura. La guida, sig. Marangon, vi illustrerà la storia della Famiglia Collalto 
                            le vicissitudini del castello e la leggenda di Bianca da Collalto.<br /> 
                            Alle 10.45 riuniti gli eventuali ritardatari, si parte a piedi per via della Tombola per un tragitto molto panoramico sulle colline e 
                            sulla piana del Piave, fino a raggiungere alle 12.15 il castello di San Salvatore a Susegana e completare la visita esterna con la guida Marangon.
                            Il tragitto a piedi dura 1,30 ore e le visite complessivamente un’altra ora e mezza. Al termine si predisporrà del recupero delle auto con 
                            appuntamento al parcheggio ai piedi del castello di Susegana nell’incrocio di via San Salvatore con via XXIV Maggio. 
                            Volendo i camminatori più coraggiosi possono continuare l’anello percorrendo via Morgante, raggiungendo il parcheggio della partenza 
                            in 7,5 km e 1,45 ore.<br /> 
                            Il pranzo è libero. Per chi volesse a Susegana, poco prima del castello c’è un grill con hamburger. Alla frazione di Collalto le trattorie 
                            consigliate sono la “Trattoria alla vecchia torre” e “Roda Mata“, una cicloristoro panoramico. 
                            Nelle vicinanze, panoramico e più raffinato, c'e' la “Casa Coste” in via Morgante n° 2 Susegana. 
                            </li>
                            <li>GIRO 3 - Colline UNESCO IN BICI - Accompagnatrice Susanna Allegri 622 <br />
                            Giro in bicicletta delle colline accompagnati dalla professionista Susanna Allegri 622.<br />
                            Questo giro e' raccomandato per persone munite di bicicletta propria o in affitto, capaci di stare in sella 4 ore, su percorsi sterrati 
                            ma anche asfaltati. 
                            Susanna mette gratuitamente a disposizione 6 biciclette non elettriche per in primi che le chiedono. Tutti devono procurarsi ed indossare 
                            un casco, portare con sè una borraccia d’acqua ed un panino. Partenza ore 9.00 dal parcheggio alberato della scuola media Giuseppe Toniolo, 
                            situato all’incrocio tra via  Mire e via stadio a Pieve di Soligo. Da li' si prosegue per la latteria Soligo, si gira a nord di Soligo e 
                            si sale all’ameno osservatorio di Collagù - Pausa caffè offerto da Susanna-, quindi si prosegue per Farra di Soligo, torri di Credazzo, 
                            e Guia, Follo. Il giro prevede visita a  “botteghe della “strada del vino bianco” di Bepi Schiratti, pranzo libero con lo spuntino, oppure 
                            (da prenotare) alla Trattoria Ristoro “Fos de Marai” a S.Stefano con bella vista panoramica sul cuore di colli UNESCO. 
                            Più in là ci sono anche altri ristoranti: “Osteria Gallina Alessia “, “Osteria da Maria” o “Osteria le colture”. 
                            Da S.Stefano ritorno per Guia, Comellere, Combai, Miane, Campea, Pieve di Soligo. Ritorno all’auto per le 14.30.
                            </li>                        
                        </ul>
                        </CardText>
                    </CardBody>
                </Card>
                <Row className="section-panel">
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle>Dopo pranzo, tutti alle Fade per la foto storica di gruppo</CardTitle>
                                <CardText>via Cucco 27, Susegana</CardText>
                                <CardText>Inizio ore 16.00</CardText>
                                <CardText>
                                Dopo i giri avete una pausa  per rinfrescarvi e prepararvi per la foto di gruppo.
                                Le auto dovranno essere parcheggiate lasciando libero il piazzale sotto la casa colonica dove ci raduneremo per la foto. 
                                La foto verrà scattata dal professionista fotografo Diego De Martin 6920 (marito di Rebecca Schiratti) 
                                e verra' spedita a tutti i partecipanti via email.
                                Su richiesta di alcuni faremo la foto di tutti di terza generazione, ovvero i “3 cifre in coccarda”.
                                </CardText>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <CardBody>
                                <div key={2} >
                                    <MapComponent lat={45.88049710730733} lng={12.20870396946714} name={"Le Fade"}/>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className="section-panel">
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle>Anguriata e Giochi</CardTitle>
                                <CardText>Via Cucco, 31, Susegana</CardText>
                                <CardText>Inizio ore 16:30</CardText>
                                <CardText>
                                Si svolge nel prato sotto la casa “dei Ricci”, circondata dai vigneti di Prosecco. 
                                Ci saranno giochi a premi e quiz sulla storia della nostra famiglia, organizzati da 
                                Elisabetta e Susanna Zanettin, con altri preziosi collaboratori.
                                Ci sara' un tavolo di check-in per pagare la cena da Leo (si raccomanda di portare soldi perche'
                                qui non siamo muniti di POS). Saremo disponibile anche per quelli che non avesssero ancora ritirato coccarde e libro. 
                                </CardText>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <CardBody>
                                <div key={3} >
                                    <MapComponent lat={45.881891949507306} lng={12.20799507724745} name="Casa Ricci"/>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className="section-panel">
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle>Cena da Leonardo Ricci (633)</CardTitle>
                                <CardText>L’Accademia dello Spiedo - Casa delle associazioni</CardText>
                                <CardText>via Giacomo Battistella n. 1, Pieve di Soligo</CardText>
                                <CardText>Inizio ore 19:00</CardText>
                                <CardText>
                                Leonardo Ricci, Maestro dell'Accademia dello spiedo dell’Alta Marca Trevigiana (o come lui la chiama: 
                                “l’accademia dei menarrosti”), preparerà uno spiedo da manuale, cotto davanti a noi, con tre contorni, 
                                acqua e vino. 
                                Per i vegetariani solo su prenotazione sarà possibile avere al posto dello spiedo, un pasto caldo a 
                                base di pasta al forno e contorno preparato da Donatella con Leo. 
                                Non siamo in grado di fornire pasti per i Vegani e i Celiaci.
                                Tutti sono invitati anche senza cena per passare un'altra serata in compagnia.
                                </CardText>
                                <CardText>Costo: {PREZZI.LEO_a}€ per gli adulti e {PREZZI.LEO_b}€ per i bambini sotto i 10 anni</CardText>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <CardBody>
                                <div key={4} >
                                    <MapComponent lat={45.9035043523799} lng={12.169573269812997} name="Casa delle associazioni"/>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Card>
                    <CardBody>
                        <CardTitle>Domenica 31 Agosto, 2025</CardTitle>
                        <CardText>Questo è l'ultimo giorno del raduno, ma anche il più importante: commemoriamo i nostri antenati,
                            scambiamo quattro ciacole a pranzo con vecchi e nuovi cugini, ascoltiamo i discorsi dei nostri decani,
                            ci immortaliamo nella foto di gruppo e, felici di far parte di questa grande famiglia, rientriamo a casa.
                        </CardText>
                    </CardBody>
                </Card>
                <Row className="section-panel">
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle>Messa alla Chiesa di San Martino al cimitero di Pieve di Soligo</CardTitle>
                                <CardText>Via S. Martino, 47, Pieve di Soligo</CardText>
                                <CardText>Ore 10:00 visita al cimitero adiacente<br />
                                    Ore 11:00 Santa Messa nella Chiesa di San Martino</CardText>
                                <CardText>
                                </CardText>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <CardBody>
                                <div key={6} >
                                    <MapComponent lat={45.90595401516669} lng={12.177926415284881} name="cimitero di Pieve di Soligo"/>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className="section-panel">
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle>Pranzo al <a href="https://www.dabrun.it/" target="_blank" rel="noopener noreferrer">
                                Ristorante da Brun
                                    </a></CardTitle>
                                <CardText>Località Caneve de Ronch, 2, 
                                    31030 Cison di Valmarino TV</CardText>
                                <CardText>Ore 12:30</CardText>
                                <CardText>
                                Antipasti vari: caponata, polpettone, insalata russa, musetto, ecc.
                                Scelta tra tre primi: pasticcio di carne, gnocchetti alle ortiche con ricotta affumicata o
                                tagliatelle al sugo di capriolo.<br />
                                Niente secondo, ma contorni cotti e crudi.<br />
                                Acqua, vino e caffè inclusi. Si paga alla cassa del ristorante.<br />
                                Qui faremo una seconda foto di gruppo nel caso qualcuno non fosse stato presente il Sabato pomeriggio.
                                </CardText>
                                <CardText>
                                Costo: {PREZZI.BRUN_a}€ per adulti e {PREZZI.BRUN_b}€ per bambini sotto gli 8 anni.
                                </CardText>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <CardBody>
                                <div key={7} >
                                    <MapComponent lat={45.9477078686326} lng={12.184132254266329} name="Ristorante da Brun"/> 
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                {/* <Row className="section-panel">
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle>Foto di gruppo a Villa Brandolini</CardTitle>
                                <CardText>Piazza Liberta', 7, Solighetto</CardText>
                                <CardText>Ore 16:00</CardText>
                                <CardText>
                                Questa sara' la seconda foto di gruppo nel caso qualcuno non fosse stato presente il Sabato pomeriggio.
                                Dal ristorante si potra' facilmente camminare fino al parco adiacente Villa Brandolini, 
                                luogo strategico per una bella foto panoramica. Seguiranno i saluti finali.
                                </CardText>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <CardBody>
                                <div key={8} >
                                    <MapComponent lat={45.91571654353343} lng={12.168251454491786} name="Villa Brandolini"/>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row> */}
            </Container>
        );
    }
}


            